import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ListGroup, Row, Col, Card, Navbar } from 'react-bootstrap'

import Meta from '../components/Meta'



import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

  


export const AgentsScreen = ({match, history}) => {
    const dispatch = useDispatch()
    const [selectedSection, setSelectedSection] = useState("") 
    const [data, setData] = useState([])
    const [viewMode, setViewMode] = useState('whatislaeyerz')

    useEffect(() => {}, [])

    return(
        
        <div style={{margin:"10px", padding:"10px"}}>
            <Meta title={'Laeyerz'} description={'Building AI Agents with Laeyerz'}/>
            
            <Navbar></Navbar>

            <Row>
                <Col style={{maxWidth:'15vw', minWidth:'15vw'}}>
                <ListGroup>
                    <ListGroup.Item style={{border:"None"}}>What are AI Agents</ListGroup.Item>
                    <ListGroup.Item style={{border:"None"}}>Chroma DB</ListGroup.Item>
                    <ListGroup.Item style={{border:"None"}}>MongoDB</ListGroup.Item>
                </ListGroup>
                
                </Col>
                <Col>

                <section id='openai-node' style={{marginBottom:'10px'}}>

                <Card style={{border:"None"}}>
                    <Card.Header style={{border:"None"}}>
                        <p className='h4'>What are AI Agents?</p>

                    </Card.Header>
                    <Card.Body>
                        AI agents are a type of AI system that is designed to perform tasks or solve problems autonomously.

                    </Card.Body>
                </Card>

                <Card style={{border:"None"}}>
                    <Card.Header style={{border:"None"}}>
                        <p className='h4'>Creating an Agent with Laeyerz is about adding conditional edges and lettig the llm figure out the next step</p>

                    </Card.Header>
                    <Card.Body>
                        Add the API key.
                        Select the action.
                        Pick the relevant parameters.

                    </Card.Body>
                    </Card>

                </section>
                            
                <section id='chroma-db' style={{marginBottom:'10px'}}>
                <Card style={{border:"None"}}>
                    <Card.Header style={{border:"None"}}>
                        <p className='h4'>ReAct Agent</p>

                    </Card.Header>
                    <Card.Body>
                        Using the UI tab, test node with different inputs.

                    </Card.Body>
                </Card>
                </section>
               

               

                
                </Col>
            </Row>




 
        </div>
    )
}

export default AgentsScreen


